<template>
  <v-dialog v-model="appointmentDialog" width="900" persistent v-if="computedSelectedSlot">
    <v-card class="hoh-entry-form">
      <v-card-title class="headline primary white--text" primary-title
        >Appointment Booking
        <v-spacer></v-spacer>
        <v-btn @click="closeModal()" left text fab small color="white"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert type="info" text class="mt-4 mx-auto font-bold" style="max-width: 600px">
          {{ computedAppointmentDate }} - {{ computedAppointmentTime }}, Duration {{ computedSelectedSlot.duration }} minutes
        </v-alert>
        <v-form ref="hohEntryForm">
          <div class="my-4">
            <label class="primary--text title">Personal Info</label>
            <v-divider class="title-border"></v-divider>
          </div>

          <!-- first name patient -->
          <v-row>
            <v-col sm="6">
              <v-text-field
                outlined
                dense
                label="First Name Patient"
                type="text"
                :rules="[(v) => !!v || 'This field is required']"
                class="required"
                v-model="formData.firstNamePatient"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <!-- last name patient -->
              <v-text-field
                outlined
                dense
                label="Last Name Patient"
                type="text"
                class="required"
                :rules="[(v) => !!v || 'This field is required']"
                v-model="formData.lastNamePatient"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="6">
              <!-- Birthday -->
              <v-dialog
                ref="dialogBirthDay"
                v-model="birthDatePatientDialogOpen"
                :close-on-content-click="false"
                transition="scale-transition"
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="birthdaypicker-custom required"
                    :value="computedBirthDatePatient"
                    outlined
                    dense
                    :rules="[(v) => !!v || 'This field is required']"
                    append-icon="mdi-calendar"
                    clearable
                    label="Birthdate Patient"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" min="1900-01-01" @change="saveBirthDay($event)">
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col sm="6">
              <!-- address patient -->
              <v-text-field
                label="Address Patient"
                type="text"
                class="required"
                :rules="[(v) => !!v || 'This field is required']"
                outlined
                dense
                v-model="formData.addressPatient"
                append-icon="mdi-map-marker"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="6">
              <!-- phone patient -->
              <v-text-field
                label="Phone Patient"
                type="tel"
                v-model="formData.phonePatient"
                outlined
                class="required"
                dense
                append-icon="mdi-phone"
                :rules="[(v) => !!v || 'This field is required']"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <!-- email -->
              <v-text-field
                label="Email Patient"
                type="email"
                class="required"
                :rules="emailRules"
                v-model="formData.emailPatient"
                outlined
                dense
                append-icon="mdi-email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-select
                outlined
                dense
                :items="['Phone', 'Email', 'WhatsApp']"
                label="Application Through"
                class="required"
                :rules="[(v) => !!v || 'This field is required']"
                v-model="formData.applicationThrough"
              ></v-select>
            </v-col>
          </v-row>

          <div class="my-4">
            <label class="primary--text title">Medical Info</label>
            <v-divider class="title-border"></v-divider>
          </div>

          <!-- self pay -->
          <v-switch v-model="formData.selfPay" label="Self Pay"> </v-switch>

          <v-row>
            <v-col sm="6">
              <!-- azv number -->
              <v-text-field
                outlined
                dense
                label="Policy/AZV Number"
                type="text"
                :rules="rulesRequiredOnselfPay"
                v-model="formData.policyNumber"
                :class="formData.selfPay ? '' : 'required'"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <!-- doctor info -->
              <v-autocomplete
                clearable
                :disabled="doctorOptions.length == 0"
                :loading="doctorOptions.length == 0"
                v-model="formData.doctorId"
                data-lpignore="true"
                outlined
                :rules="rulesRequiredOnselfPay"
                :class="formData.selfPay ? '' : 'required'"
                dense
                :items="doctorOptions"
                label="Doctor"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <div class="my-4">
            <label class="primary--text title">Other</label>
            <v-divider class="title-border"></v-divider>
          </div>

          <!-- comment -->
          <v-row>
            <v-col sm="6">
              <v-textarea label="Comment" outlined v-model="formData.comment" :rules="rulesComment" :counter="maxCommentChars"></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal()"> Cancel </v-btn>
        <v-btn color="success" :disabled="submittingForm" @click="submit()" class="mx-4">
          Submit
          <v-icon right>mdi-send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { AppointmentFormFieldKeys } from '../models/appointment-form-field-keys.js';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      formDataPrestine: JSON.stringify(new AppointmentFormFieldKeys()),
      formData: new AppointmentFormFieldKeys(),
      applicationDateMenuOpen: false,
      appointmentDateMenuOpen: false,
      appointmentDate: null,
      sampleDateMenuOpen: false,
      birthDatePatientDialogOpen: false,
      required: false,
      submittingForm: false,
      maxCommentChars: 250,
      rulesComment: [(v) => v == '' || v == null || (v && v.length <= this.maxCommentChars) || `Max ${this.maxCommentChars} characters`],
      emailRules: [(v) => !!v || 'E-mail is required', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'],
      rulesRequiredOnselfPay: []
    };
  },
  watch: {
    birthDatePatientDialogOpen(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
    appointmentDialog(n, o) {
      if (this.$refs.hohEntryForm && n != o) this.$refs.hohEntryForm.reset();
    },
    selfPay: {
      immediate: true,
      handler(n) {
        if (n) {
          this.rulesRequiredOnselfPay = [];
        } else {
          this.rulesRequiredOnselfPay = [(v) => !!v || 'This field is required'];
        }
      }
    }
  },
  computed: {
    ...mapGetters({ showAppointmentBookingDialog: 'appointmentsCalendarStore/showAppointmentBookingDialog' }),
    selectedDateTime() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedAppoinmentDateTime;
    },
    computedAppointmentDate() {
      // console.log(this.selectedDateTime);
      return this.selectedDateTime ? moment.utc(this.selectedDateTime, 'YYYY-MM-DDTHH:mm').local().format('D-MMMM-YYYY') : '';
    },
    computedAppointmentTime() {
      return this.selectedDateTime ? moment.utc(this.selectedDateTime, 'YYYY-MM-DDTHH:mm').local().format('hh:mm A') : '';
    },
    computedBirthDatePatient() {
      return this.formData.birthDatePatient ? moment(this.formData.birthDatePatient, 'YYYY-MM-DD').format('D-MMMM-YYYY') : '';
    },
    computedSelectedSlot() {
      return this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedSlot;
    },
    selfPay() {
      return this.formData.selfPay;
    },
    doctorOptions() {
      return this.getDoctorOptions(); // Leaving this for lookback reference: this.$store.state.config.doctorOptions;
    },
    appointmentDialog() {
      return this.showAppointmentBookingDialog; //this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.showAppointmentBookingDialog;
    },
    locationSelected() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  created() {
    this.formData.applicationDate = moment().format('YYYY-MM-DD') + 'T13:00:00.000Z[UTC]';
    this.appointmentDate = moment(this.selectedDate).format('YYYY-MM-DD');

    if (this.doctorOptions.length == 0) this.fetchDoctorOptions(); //this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions');
  },
  methods: {
    submit() {
      if (!this.$refs.hohEntryForm.validate()) return;

      this.formData.agendaSlotId = this.computedSelectedSlot.id;
      this.formData.createdBy = this.$store.state.config.userObject.preferred_username;

      let dataToPost = JSON.parse(JSON.stringify(this.formData));

      this.submittingForm = true;
      this.$store.commit('SET_SHOW_LOADER', {
        action: true,
        text: 'One moment...'
      });
      this.$store.dispatch('appointmentsCalendarStore/submitAppointment', dataToPost).then((data) => {
        this.submittingForm = false;
        this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });

        this.reloadPageData();

        if (data) {
          this.closeModal();
          let payload = {
            open: true,
            text: 'Entry successfully created.',
            color: 'success'
          };
          this.$store.commit('SET_SNACKBAR', payload);
        }
      });
    },
    formatDate(d) {
      return moment(d, 'YYYY-MM-DD').format('DD-MMM-YYYY');
    },
    saveBirthDay(value) {
      this.formData.birthDatePatient = value + 'T13:00:00.000Z[UTC]';
      this.birthDatePatientDialogOpen = false;
    },
    closeModal() {
      this.$store.commit('appointmentsCalendarStore/SET_APPOINTMENT_BOOKING_DIALOG', false);
    },
    reloadPageData() {
      let selectedDate = this.$store.state.appointmentsCalendarStore.appointmentsSelectedDayPage.selectedDate;
      this.$store.commit('appointmentsCalendarStore/SET_SINLGE_SLOT_LOADER', { id: this.computedSelectedSlot.id, action: true });
      this.$store
        .dispatch('appointmentsCalendarStore/getCalenderDaySlots', {
          minDate: selectedDate,
          maxDate: selectedDate,
          showLoader: false,
          locationId: this.locationSelected.id
        })
        .finally(() => {
          this.$store.commit('appointmentsCalendarStore/SET_SINLGE_SLOT_LOADER', { id: this.computedSelectedSlot.id, action: false });
        });
      this.$store.dispatch('appointmentsCalendarStore/getCalenderDayManualAppointments', {
        minDate: selectedDate,
        maxDate: selectedDate,
        locationId: this.locationSelected.id
      });
    },
    ...mapActions('doctorOptionsStore', ['fetchDoctorOptions']),
    ...mapGetters('doctorOptionsStore', ['getDoctorOptions'])
  }
};
</script>
